import {Component, OnInit, ViewChild, Inject, ChangeDetectorRef, AfterViewInit} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatTableDataSource, MatPaginator, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AtLeastOneValidator } from './at-least-one.validator';
import { UserSearchService } from '../../../core/services/user-search.service';

@Component({
	selector: 'kt-dialog-search-user',
	templateUrl: './dialog-search-user.component.html',
	styleUrls: ['./dialog-search-user.component.scss']
})
export class DialogSearchUserComponent implements OnInit, AfterViewInit {

	searchForm: FormGroup;
	isReferrerSearch: boolean = false;
	displayedColumns = ['username', 'nombre', 'apellido', 'dni', 'select'];
	dataSource = new MatTableDataSource<Element>(ELEMENT_DATA);
	itemsSearch: any[] = [];
	isSearching: boolean = false;
	userName: string = '';

	@ViewChild(MatPaginator) paginator: MatPaginator;

	constructor(
		private fb: FormBuilder,
		private http: HttpClient,
		private dialogRef: MatDialogRef<DialogSearchUserComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: DialogData,
		private userSearchService: UserSearchService,
	) { }

	ngOnInit() {
		this.paginator._intl.itemsPerPageLabel = 'Items por página';
		this.initSearchForm();
	}

	ngAfterViewInit() {
		this.dataSource.paginator = this.paginator;
	}

	search() {
		const controls = this.searchForm.controls;
		if (this.searchForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}
		if (this.data.isReferrerSearch){
			this.isReferrerSearch = this.data.isReferrerSearch;
		}

		let userSearch = {
			filter: {
				userName: controls['username'].value,
				lastname: controls['apellido'].value,
				firstname: controls['nombre'].value,
				documentnumber: controls['dni'].value,
				isreferrersearch: this.isReferrerSearch
			},
			sortOrder: null,
			sortField: null,
			pageNumber: this.paginator.pageIndex + 1,
			pageSize: this.paginator.pageSize,
		};

		this.isSearching = false;
		const httpHeaders = new HttpHeaders();
		httpHeaders.set('Content-Type', 'application/json');
		this.isSearching = true;
		this.userSearchService.searchUser(userSearch).subscribe(
			value => {
				let items = value['items'];
				this.dataSource = new MatTableDataSource<Element>(items);
				this.isSearching = false;
			},
			error => {
				this.dataSource = new MatTableDataSource<Element>();
                this.isSearching = false;
			});
	}

	initSearchForm() {
		this.searchForm = this.fb.group({
			username: [this.data.userName ? this.data.userName : null],
			dni: [null],
			apellido: [null],
			nombre: [null],
		}, {
			validator: Validators.compose([
				AtLeastOneValidator.atLeastOne,
				AtLeastOneValidator.nameCompleted
			])
		});

		if (this.data.userName) {
			setTimeout(() => {
				this.search();
			});
		}
	}

	clickRow(row) {
		this.dialogRef.close(row);
	}

	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.searchForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}

}

export interface DialogData {
	userName: string;
	userId: string;
	isReferrerSearch: boolean;
}

const ELEMENT_DATA: Element[] = [];
